import { ref } from 'vue'

const isInput = ref(false)
const isSelect = ref(false)

export const useInputSelectSearch = () => {
  return { isInput, isSelect }
}
